import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMySharedAlbumsList, getMyFriendsAlbumsList, albumsDataReset } from "../meta/slices"
import { mySharedAlbumsData, sharedAlbumsLimit, myFriendsAlbumsData } from "../meta/selectors"
import IterateAndGenerateAlbumDom from './iterate_and_generate_album_dom';
import { useInView } from 'react-intersection-observer';
import IConstants from '../meta/constants';
import album_options_events from './album_options_events';
import {toggleElementById} from "../../../utils/common_utils"

/* global photoOrg */

const logAlbumsInfoFirstTime = (data) =>{
    if(photoOrg.logAlbumsCount.myShared) {
        photoOrg.clientLogger.warn({description: "SharedAlbumsComponent::logAlbumsInfoFirstTime:My Shared Albums count ", mySharedAlbumsCount: data.totalEntitiesCount});
        photoOrg.logAlbumsCount.myShared = false;  // making the key false as soon as we logged the albums count for the first time
    }
}

const getDataCenterFromResponse = (data) =>{
    try {
        if (photoOrg.config.dc === undefined && data.entities !== undefined) {
            if (data.entities[0] && data.entities[0].dataCenter) {
                photoOrg.config.dc = data.entities[0].dataCenter;
            }
            else if (data.entityMap && data.entityMap.length > 0) {
                photoOrg.config.dc = Object.keys(data.entityMap)[0].dataCenter
            }
            photoOrg.photoLib.collectionStructure.dataCenter = photoOrg.config.dc
        }
    } catch (e) {
        photoOrg.clientLogger.error({description: "SharedAlbumsComponent:getDataCenterFromResponse:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
    }
}



const SharedAlbumsComponent = ({sortOrder, accessType}) =>{
    try{
        const dispatch = useDispatch();
        const mySharedAlbumsResponse = useSelector(mySharedAlbumsData);
        const myFriendsAlbumsResponse = useSelector(myFriendsAlbumsData);
        const [showBottomLoadingBar, setShowBottomLoadingBar] = useState(true);
        const skip = useRef(0);
        const [ref, inView] =  useInView({
            //Optional options */
           threshold: 0.5,
       });

       useEffect(()=>{
        return () => {
            skip.current = 0;
            dispatch(albumsDataReset())
        }
       },[])

       useEffect(()=>{
        const resetState = () =>{
            console.log("resetting the state");
            dispatch(albumsDataReset())
        }

        document.removeEventListener("resetTheState",resetState);
        document.addEventListener("resetTheState", resetState);
       },[])
       
        useEffect(() =>{

            if(accessType === IConstants.SHAREDWITHME){
                const params = {
                    type : "received",
                    friendsInfo : "true",
                    skip : skip.current,
                    limit : sharedAlbumsLimit,
                    sortOrder : sortOrder
                }
                dispatch(getMyFriendsAlbumsList(params));
            }else{
                const params = {
                    type : "ownedShared",
                    friendsInfo : "true",
                    skip : skip.current,
                    limit : sharedAlbumsLimit,
                    sortOrder : sortOrder
                }
                dispatch(getMySharedAlbumsList(params));
            }
            
        },[])

        useEffect(() =>{
            if(mySharedAlbumsResponse && mySharedAlbumsResponse.resultCount < sharedAlbumsLimit){
                setShowBottomLoadingBar(false)
            }
            if(Object.keys(mySharedAlbumsResponse).length > 0 || Object.keys(myFriendsAlbumsResponse).length > 0){
                loadMySharedAlbums();
            }
        },[mySharedAlbumsResponse, myFriendsAlbumsResponse])

        useEffect(()=>{
           if(inView && Object.keys(mySharedAlbumsResponse).length > 0) {
                skip.current = skip.current + sharedAlbumsLimit;
                const params = {
                    type : "ownedShared",
                    friendsInfo : "true",
                    skip : skip.current,
                    limit : sharedAlbumsLimit,
                    sortOrder : sortOrder
                }
                dispatch(getMySharedAlbumsList(params));
            }else if(inView && Object.keys(myFriendsAlbumsResponse).length > 0){
                skip.current = skip.current + sharedAlbumsLimit;
                const params = {
                    type : "received",
                    friendsInfo : "true",
                    skip : skip.current,
                    limit : sharedAlbumsLimit,
                    sortOrder : sortOrder
                }
                dispatch(getMyFriendsAlbumsList(params));
            }
        },[inView])
       
       
        
        const loadMySharedAlbums =() =>{
            try{
                toggleElementById("loadingBar", "none");
                if(photoOrg.aggSdkUtils.isTabbedView()){
                    document.getElementById('album-sorting').setAttribute('aria-expanded', 'false');
                    document.getElementById('share_filters').setAttribute('aria-expanded', 'false');
                }
                //setting to false as redirection should be done only once on load of library/picker if there are no google albums
                photoOrg.photoLib.redirectToHostTab = false;
                photoOrg.photoLib.hideTransparentSubTitleBar();
                if (photoOrg.history.historyState.pg != photoOrg.constants.MY_SHARED_ALBUM_VIEW) {
                    const accountHasOwnedAlbums = photoOrg.storage.getValueFromStorage(photoOrg.constants.storagekeys.ACCOUNT_HAS_PHOTOS,{addAccountId : true, useLocalStorage:true});

                    if (myFriendsAlbumsResponse.resultCount === 0 && skip.current === 0) {//data is empty when they are not friends albums
                        //When they are no albums, set the account_has_friends_photos to false.
                        photoOrg.storage.setValueInStorage(photoOrg.constants.storagekeys.ACCOUNT_HAS_FRIENDS_PHOTOS,false,{addAccountId : true, useLocalStorage:true});
                        album_options_events.checkAndRedirectMYFriendsToNoPhotosPage(accountHasOwnedAlbums);
                        photoOrg.Util.captureOnLoadPaintMetrics();
                        return;
                    } else if(myFriendsAlbumsResponse.entities.length === 0){
                        if(!photoOrg.photoLib.config.loadAsPhotoPicker){
                            photoOrg.history.historyState.pg = "av"
                            photoOrg.history.appendHashtoURL(photoOrg.history.historyState);
                        }else{
                            photoOrg.libraryController.handleAlbumsView();
                        }
                    }
                    else if (myFriendsAlbumsResponse.resultCount > 0 && skip.current === 0) {
                        photoOrg.photoLib.showAndHideUploadTextDiv("hide");
                        photoOrg.photoLib.showAndHideSharedEmptyMsgDiv("hide");
                        if(accountHasOwnedAlbums === "false" && !photoOrg.aggSdkUtils.isTabbedView()) {//if account has no owned album but has friends album then hide options in main header.
                            photoOrg.photoLib.showAndHideSubheaderOptions('hide');
                            photoOrg.uploadButtonToolTip = new photoOrg.LibraryToolTip({divId:"#addPhotosSection", type:photoOrg.constants.omniture.UPLOAD_TIP, tipDirection:"top",message:photoOrg.translations.photos['sub_header']['friends_upload_tooltip']})
                        }else//show the sub header options if they are hidden.
                            photoOrg.photoLib.showAndHideSubheaderOptions('show');
                        //When friends albums are present, set the account_has_friends_photos to true.
                        photoOrg.storage.setValueInStorage(photoOrg.constants.storagekeys.ACCOUNT_HAS_FRIENDS_PHOTOS,true,{addAccountId : true, useLocalStorage:true});
                        photoOrg.photoLib.UserAssetsInfo.albumListLength = parseInt(myFriendsAlbumsResponse.totalEntitiesCount);
                        photoOrg.tracker.setTotalSharedWithMeAlbumsCount(myFriendsAlbumsResponse.totalEntitiesCount);
                    }
                    if (myFriendsAlbumsResponse.resultCount !== undefined && (myFriendsAlbumsResponse.resultCount == 0)) {
                        photoOrg.photoLib.isTotalAlbumsLoaded = true;
                        setShowBottomLoadingBar(false);
                    }
                }else{
                    if (mySharedAlbumsResponse.resultCount === 0 && skip.current === 0) {
                        photoOrg.photoLib.showAndHideSharedEmptyMsgDiv("show");
                        photoOrg.Util.captureOnLoadPaintMetrics();
                    } else if(mySharedAlbumsResponse.entities.length === 0){
                        if(!photoOrg.photoLib.config.loadAsPhotoPicker){
                            photoOrg.history.historyState.pg = "av"
                            photoOrg.history.appendHashtoURL(photoOrg.history.historyState);
                        }else{
                            photoOrg.libraryController.handleAlbumsView();
                        }
                    }
                    else if (mySharedAlbumsResponse.resultCount > 0 && skip.current === 0) {
                        photoOrg.photoLib.showAndHideUploadTextDiv("hide");
                        //check the importance
                        //$(".photo-Org #sub_header_container").show();
                        photoOrg.photoLib.UserAssetsInfo.albumListLength = parseInt(mySharedAlbumsResponse.totalEntitiesCount);
                        photoOrg.tracker.setTotalMySharedAlbumsCount(mySharedAlbumsResponse.totalEntitiesCount);
                    }
                    //hide bottomLoadingBar
                    if (mySharedAlbumsResponse.resultCount !== undefined && (mySharedAlbumsResponse.resultCount === 0 || mySharedAlbumsResponse.resultCount < sharedAlbumsLimit)) {
                        setShowBottomLoadingBar(false);
                    }
                    logAlbumsInfoFirstTime(mySharedAlbumsResponse);
                    getDataCenterFromResponse(mySharedAlbumsResponse);
                    //removing temp-message dom as we are holding same div for albums
                    document.querySelectorAll(".photo-Org .albumsGridList .sources-unavailable-msg").forEach(el => el.remove());
                    document.querySelectorAll(".social_source_connect").forEach(el => el.remove())
                    photoOrg.photoLib.showAndHideUploadTextDiv('hide');
                    photoOrg.reBuiltMonthCalendar = false;
                }
            }catch(e){
                photoOrg.clientLogger.error({description: "SharedAlbumsComponent:loadMySharedAlbums:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
            }
        }
        return(
            <>
                {(Object.keys(mySharedAlbumsResponse).length > 0 )?
                    <IterateAndGenerateAlbumDom rid="IterateAndGenerateAlbumDom" selectionSharedAlbumsRes={mySharedAlbumsResponse.entities}  accessType={accessType} /> 
                    : null
                }
                <div className='share_tab_albumicons'>
                    {(Object.keys(myFriendsAlbumsResponse).length > 0 )?
                        <IterateAndGenerateAlbumDom rid="IterateAndGenerateAlbumDom" selectionSharedAlbumsRes={myFriendsAlbumsResponse.entities}  accessType={accessType} /> 
                        : null
                    }
                </div>
                { showBottomLoadingBar ?  
                    (<div id="bottomLoadingBar" className='text-center' ref={ref}>
                        <span className="icon-po-spin5 animate-spin"></span>
                        <div className="loading-dots mediumdots"><span role="status" className="dotid"></span></div>
                    </div>) 
                    : null 
                } 
            </>
        )
    }catch(e){
        photoOrg.clientLogger.error({description: "LIBRARY:Albums:SharedAlbumsComponent:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
    }
}

export default SharedAlbumsComponent;